import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { Injectable } from "@angular/core";


@Injectable()
export class AppDateAdapter extends NativeDateAdapter {

  parse(value: any): Date | null {
    if ((typeof value === 'string')) {
      const regExpr = /[^0-9/]/g;
      value = value.replace(regExpr, '');
      let year: number;
      let date: number;
      let month: number;
      if ((value.split("/").length === 3) && value.length == 10) {
        const str = value.split('/');
        let yyyy = str[2];
        let dd = str[1];
        let mm = str[0];
        let mmmLen = mm.length;
        if (mmmLen > 2) {
          let mmdummy = mm;
          mm = mmdummy.slice(0, 2);
          dd = mmdummy.slice(2, mmmLen) + dd;
        }
        let ddLen = dd.length;
        if (ddLen > 2) {
          let dddummy = dd;
          dd = dddummy.slice(0, 2);
          yyyy = dddummy.slice(2, ddLen) + yyyy;
        }
        year = Number(yyyy);
        date = Number(dd);
        month = Number(mm);
        if (date === 0 || month === 0 || year === 0) {
          return null;
        }
        if (month > 12) {
          return null;
        }
        if (this.ValidateDay(date, month, year)) {
          return null;
        }
        return new Date(this._toYear(year), (month - 1), date);
      }
      else {
        return null;
      }
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }
  format(date: Date, displayFormat: string): string {
    if (displayFormat === 'input') {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      return this._to2digit(month) + '/' + this._to2digit(day) + '/' + year;
    } else if (displayFormat == 'inputMonth') {
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      return this._to2digit(month) + '/' + year;
    } else {
      return date.toDateString();
    }
  }

  private _to2digit(n: number) {
    return ('00' + n).slice(-2);
  }
  private _toYear(year: number) {
    const currentYear = new Date().getFullYear();
    let century = Number((currentYear / 100).toFixed());
    const last2Digits = Number(currentYear.toString().slice(2, 4));
    century = year.toString().length == 2 ? (last2Digits >= year ? century : (century - 1)) : century;
    return year.toString().length < 3 ? ((century * 100) + year) : year;
  }

  private ValidateDay(day: number, month: number, year: number): boolean {
    const longMonth = [1, 3, 5, 7, 8, 10, 12];
    const short = [];
    if (longMonth.indexOf(month) != -1) {
      return day > 31;
    }
    else if (month == 2) {
      if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
        return day > 29;
      }
      else {
        return day > 28;
      }
    }
    else {
      return day > 30;
    }
  }
}

export const APP_DATE_FORMATS =
{
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' }
  },
  display: {
    // dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
    dateInput: 'input',
    // monthYearLabel: { month: 'short', year: 'numeric', day: 'numeric' },
    monthYearLabel: 'inputMonth',
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  }
}
